import { LinkAction } from '@leverege/molten/routes';
import { GlobalState } from '@leverege/ui-redux';
import { Config } from '@leverege/plugin';
import OpenApiGroupDelegate from "../../delegates/openApi/OpenApiGroupDelegate.js";
export default ({
  id,
  relationship
}) => LinkAction.create({
  id,
  layout: Config.get(id, 'layout', {
    sort: relationship.blueprint.getTagStartingWith('navSortUserManagement:', true) || 'zzz',
    sectionName: relationship.blueprint.getString('userManagementSectionName')
  }),
  matches: {
    use: 'navBar',
    client: 'ItemScreen',
    path: relationship.path
  },
  isPrepared: cxt => {
    const {
      clientProps: {
        match
      }
    } = cxt;
    const delegate = new OpenApiGroupDelegate({
      relationship: relationship.createResolved(match),
      match
    });
    return delegate.canAction(GlobalState.get(), 'listUsers') != null;
  },
  prepare: cxt => {
    const {
      clientProps: {
        match
      }
    } = cxt;
    const delegate = new OpenApiGroupDelegate({
      relationship: relationship.createResolved(match),
      match
    });
    return GlobalState.dispatch(delegate.requestCanAction(null, null, path => `${path}/user`, 'get', 'listUsers'));
  },
  handles: cxt => {
    const {
      clientProps: {
        match
      }
    } = cxt;
    const delegate = new OpenApiGroupDelegate({
      relationship: relationship.createResolved(match),
      match
    });
    return delegate.canAction(GlobalState.get(), 'listUsers');
  },
  get name() {
    return 'Access';
  },
  icon: 'https://storage.googleapis.com/relay-hub-ui-assets/access-nav.svg',
  path: `/${relationship.urlPath}/access`
});